'use client';

import type { ProductToCompareT } from '../../../../../../type/product/productComparison';
import {
  ProductComparisonClearAll,
  ProductComparisonClearAllLabel,
  ProductComparisonLabelCell,
  ProductComparisonLabelCellVariant,
  ProductComparisonRow,
  ProductComparisonRowVariant,
} from '@vs-shop/commerce-ui/productComparison';
import { X } from 'lucide-react';
import { useIntl } from 'react-intl';

import { productComparisonDrag, productComparisonDrop } from '../../dragState';

import ProductsComparisonDragWrapper from '../../ProductsComparisonDragWrapper';
import ProductComparisonActionsCell from './ProductComparisonActionsCell';

import { clearProductCodesAtom } from '@vs-shop/engine/atom/productsComparison/productsComparison';
import { useAtomSet } from '@effect/atom-react';

type Props = {
  products: readonly ProductToCompareT[];
  draggingIndex: number | null;
  dragOverIndex: number | null;
  onDragStartAction: (index: number) => void;
  onDragOverAction: (index: number) => void;
  onDragEndAction: () => void;
  onDropAction: (fromIndex: number, toIndex: number) => void;
};

export default function ProductComparisonActionsRow({
  products,
  draggingIndex,
  dragOverIndex,
  onDragStartAction,
  onDragOverAction,
  onDragEndAction,
  onDropAction,
}: Props) {
  const intl = useIntl();

  const clearComparisonProductCodes = useAtomSet(clearProductCodesAtom);

  const handeClearComparisonProductCodes = () => {
    clearComparisonProductCodes();
  };

  return (
    <ProductComparisonRow variant={ProductComparisonRowVariant.PLAIN}>
      {/* LEFT INFO */}
      <ProductComparisonLabelCell variant={ProductComparisonLabelCellVariant.HEADER_OPEN_FLUSH}>
        <ProductComparisonClearAll onClick={handeClearComparisonProductCodes}>
          <X className="size-4 shrink-0 lap:size-5" />
          <ProductComparisonClearAllLabel>
            {intl.formatMessage({
              id: 'ProductsComparisonHeaderColumnCellInfo.clearComparisonProductCodes',
              defaultMessage: 'Smazat vše',
            })}
          </ProductComparisonClearAllLabel>
        </ProductComparisonClearAll>
      </ProductComparisonLabelCell>

      {/* PRODUCT COLUMNS */}
      {products.map((product, index) => (
        <ProductsComparisonDragWrapper
          key={`actions-${product.code}`}
          index={index}
          onDragStartAction={onDragStartAction}
          onDragOverAction={onDragOverAction}
          onDragEndAction={onDragEndAction}
          onDropAction={onDropAction}
        >
          <ProductComparisonActionsCell
            product={product}
            drag={productComparisonDrag(draggingIndex, index)}
            drop={productComparisonDrop(dragOverIndex, index)}
          />
        </ProductsComparisonDragWrapper>
      ))}
    </ProductComparisonRow>
  );
}
